import { Plus, Trash2, Wand2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { newIngId } from "@/lib/recipes/scale";

export const blankIng = () => ({ id: newIngId(), qty: "", unit: "", name: "", note: "", fictional: false, fiction_desc: "" });

const Row = ({ ing, i, set, remove }) => (
  <li className="space-y-2 rounded-md border border-[#2D3442] bg-[#0F131A] p-2.5" data-testid={`recipe-ing-row-${i}`}>
    <div className="flex flex-wrap gap-2">
      <Input value={ing.qty} onChange={(e) => set({ qty: e.target.value })} placeholder="1 1/2" maxLength={20} className="h-8 w-20 text-sm" data-testid={`recipe-ing-qty-${i}`} />
      <Input value={ing.unit} onChange={(e) => set({ unit: e.target.value })} placeholder="cup" maxLength={20} className="h-8 w-24 text-sm" data-testid={`recipe-ing-unit-${i}`} />
      <Input value={ing.name} onChange={(e) => set({ name: e.target.value })} placeholder="Ingredient" maxLength={120} className="h-8 min-w-[160px] flex-1 text-sm" data-testid={`recipe-ing-name-${i}`} />
      <Input value={ing.note} onChange={(e) => set({ note: e.target.value })} placeholder="note, e.g. chopped" maxLength={200} className="h-8 w-40 text-sm" data-testid={`recipe-ing-note-${i}`} />
      <button onClick={remove} title="Remove ingredient" className="rounded p-1.5 text-[#7A7468] hover:text-[#F87171]" data-testid={`recipe-ing-remove-${i}`}><Trash2 className="h-4 w-4" /></button>
    </div>
    <label className="flex items-center gap-2 text-xs text-[#A8A090]">
      <Checkbox checked={ing.fictional} onCheckedChange={(v) => set({ fictional: !!v })} data-testid={`recipe-ing-fictional-${i}`} />
      <Wand2 className="h-3.5 w-3.5 text-[#C084FC]" />Made-up ingredient
    </label>
    {ing.fictional && <Textarea value={ing.fiction_desc} onChange={(e) => set({ fiction_desc: e.target.value })} maxLength={400} rows={2} placeholder="Describe it: taste, texture, what it's like (e.g. small silver berries, tart like cranberries)" className="text-sm" data-testid={`recipe-ing-desc-${i}`} />}
  </li>
);

export const IngredientRows = ({ list, onChange }) => {
  const set = (i, patch) => onChange(list.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  return (
    <div className="space-y-2" data-testid="recipe-ingredients-editor">
      <ul className="space-y-2">{list.map((ing, i) => <Row key={ing.id} ing={ing} i={i} set={(p) => set(i, p)} remove={() => onChange(list.filter((_, j) => j !== i))} />)}</ul>
      <button onClick={() => onChange([...list, blankIng()])} className="inline-flex items-center gap-1 text-sm text-[#F59E0B] hover:underline" data-testid="recipe-ing-add"><Plus className="h-4 w-4" />Add ingredient</button>
    </div>
  );
};

export const StepRows = ({ list, onChange }) => (
  <div className="space-y-2" data-testid="recipe-steps-editor">
    <ol className="space-y-2">
      {list.map((s, i) => (
        <li key={i} className="flex gap-2">
          <span className="mt-2 w-6 shrink-0 text-right font-display text-lg text-[#F59E0B]">{i + 1}</span>
          <Textarea value={s} onChange={(e) => onChange(list.map((x, j) => (j === i ? e.target.value : x)))} rows={2} maxLength={2000} placeholder="Describe this step" className="text-sm" data-testid={`recipe-step-${i}`} />
          <button onClick={() => onChange(list.filter((_, j) => j !== i))} title="Remove step" className="self-start rounded p-1.5 text-[#7A7468] hover:text-[#F87171]" data-testid={`recipe-step-remove-${i}`}><Trash2 className="h-4 w-4" /></button>
        </li>
      ))}
    </ol>
    <button onClick={() => onChange([...list, ""])} className="inline-flex items-center gap-1 text-sm text-[#F59E0B] hover:underline" data-testid="recipe-step-add"><Plus className="h-4 w-4" />Add step</button>
  </div>
);
